import React, {useState} from "react";
import ReactTable from "react-table-v6"
import { ArrowForward } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import { AddCircle } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import 'react-table-v6/react-table.css'

const ProductsList = (props) => {
    let history = useHistory();

    console.log(props)

    if (!props.products) return null;

    const columns = [
        {
            Header: 'Company',
            accessor: 'company',
            style: {paddingTop: 15}
        },
        {
            Header: 'Model',
            accessor: 'model',
            style: {paddingTop: 15}
        },
        {
            Header: 'Type',
            accessor: 'type',
            style: {paddingTop: 15}
        },
        {
            Header: 'Subtype',
            accessor: 'subtype',
            style: {paddingTop: 15}
        },
    ]

        return (
            <div className="product-list">
                <div className="product-add-mode">  
                    <Tooltip title="Add a New Product">   
                        <IconButton 
                                variant="contained" 
                                color="primary"
                                aria-label={"View and edit product settings" }

                                onClick={() => {
                                    history.push("/products/add")
                            }}>
                                    <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.1)"}}/>
                        </IconButton>
                    </Tooltip>
                </div> 
                <div className="section-header">Products </div>
                <div className="point-list-table">
                    <ReactTable key={(props.products && props.products.length) || 0}
                        data={props.products || []}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={10}
                        showPagination={props.products && props.products.length > 10}
                    />
                </div>
            </div>
        )
}

export default ProductsList;
